import React from "react";

import "./AvailableActionsTooltip.scss";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import DismissibleTooltip from "src/app/components/DismissibleTooltip/DismissibleTooltip";

interface AvailableActionsTooltipProps {
  tooltipId: string;
  storageKey: string;
}

export default function AvailableActionsTooltip({
  tooltipId,
  storageKey,
}: AvailableActionsTooltipProps) {
  return (
    <div className="available-actions-tooltip" data-tooltip-id={tooltipId}>
      <DismissibleTooltip
        tooltipId={tooltipId}
        title={
          <IDHFormattedMessage
            id="ws_select_at_least_one_creator"
            defaultMessage="Select at least one creator to see the available actions."
          />
        }
        storageKey={storageKey}
        checkboxLabel={
          <IDHFormattedMessage
            id="ws_dont_show_me_again"
            defaultMessage="Don't show me again"
          />
        }
        noArrow
        confirmLabel={<IDHFormattedMessage id="ws_ok" defaultMessage="Ok" />}
      />
    </div>
  );
}
